import React from 'react';
import { Container } from 'react-bootstrap';
import SelectableCard from './SelectableCard';
import '../../styles/intakeNew.scss';

function QuestionField({ title, items, selected, onChange }) {
  return (
    <Container className="question-field">
      <h5 className="question-field__title">{title}</h5>
      <div className="question-field__grid">
        {items.map(item => (
          <div className="question-field__item" key={item.value}>
            <SelectableCard
              label={item.label}
              value={item.value}
              selectedValue={selected}
              onChange={onChange}
            />
          </div>
        ))}
      </div>
    </Container>
  );
}

export default QuestionField;
